function MenuSize(selector) {

  $(document).on('scroll', window, function() {
    var h = $(document).scrollTop();
    if (h >= 100) {
      $(selector).addClass('compact');
    } else {
      $(selector).removeClass('compact');
    }
  });

}

function Membership(selector) {

  this.open = false;
  this.selector = selector;

  this.setup = function() {

    $(document).on('click', '[trigger]', function() {
      if (this.open == false) {
        this.open = true;
        $('[container]', this.selector).removeClass('hidden');
      } else {
        this.open = false;
        $('[container]', this.selector).addClass('hidden');
      }
      //console.log('Hello World');
    }.bind(this));

  }

  this.setup();
  return this;

}

function OverlayMenuLinks(selector, fatherSelector) {

  this.selector = selector;
  this.fatherSelector = fatherSelector;

  this.bindEvents = function() {

    $(document).on('click', this.selector, function() {

      // Need to find the rispective menù :)
      var p = $(this).parent().find('ul');

      if ($(p).hasClass('hidden')) {
        $('ul', this.fatherSelector).addClass('hidden');
        $(p).removeClass('hidden');
      } else {
        $(p).addClass('hidden');
      }

      console.log(p);
    });

  }

  this.bindEvents();

}

function OverlayMenu(selector, menu) {

  this.selector = selector;
  this.menu = menu;

  $(document).on('click', this.selector, function() {

    console.log('looking for ' + this.menu);

    if ($(this.menu).hasClass('hidden')) 
      $(this.menu).removeClass('hidden');
    else 
      $(this.menu).addClass('hidden');

    }
  .bind(this));

}

$(function() {

  console.log('Everyting is fine.');

  new OverlayMenuLinks('[activator]', '[overlaylink]');
  new MenuSize('[head]');
  new Membership('[membership]');
  new OverlayMenu('[trigger-overlay]', '[menu-overlay]');

});

$(document).ready(function() {
  $('.newslink ul.mt-2 li a').eq(0).attr('href', 'https://www.fipe.it/category/comunicazione/news/?type=post');

  $('.slideCarosello').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $(".openMenu").click(function() {
    $('.mobilemenu').removeClass('hidden');
    $('html , body').addClass('overflow-hidden');
  });

  $(".closeMenu").click(function() {
    $('.mobilemenu').addClass('hidden');
    $('html , body').removeClass('overflow-hidden');

  });

  $(".openNewsletter").click(function() {
    $('.modNewsletter').removeClass('hidden');
  });

  $(".closeNewsletter").click(function() {
    $('.modNewsletter').addClass('hidden');

  });

});



// WEBPACK FOOTER //
// ./scripts/autoload/base.js